module.exports = __webpack_public_path__ + "img/ico-collapse-brand-color.16c559af.svg";